var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "transparent",
      "color": "basil",
      "grow": "",
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.general")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.landing")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.report")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.app")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.licenses")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerSettingsForm.tabs.inbox")))])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "0"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-vpn")])], 1), _c('v-list-item-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, _vm._l(_vm.weekDays, function (weekday) {
    return _c('div', {
      key: weekday
    }, [_c('v-text-field', {
      attrs: {
        "type": "text",
        "label": _vm.$t("partner.PartnerDetailSettingsOpeningHoursCard.".concat(weekday)),
        "outlined": "",
        "disabled": _vm.disabled
      },
      model: {
        value: _vm.update.openingHours[weekday],
        callback: function callback($$v) {
          _vm.$set(_vm.update.openingHours, weekday, $$v);
        },
        expression: "update.openingHours[weekday]"
      }
    })], 1);
  }), 0)], 1)], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-card-account-mail")])], 1), _c('v-list-item-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.email.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.email.hint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.update.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.update.contact, "email", $$v);
      },
      expression: "update.contact.email"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.phoneRules,
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.phone.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.phone.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.contact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.update.contact, "phone", $$v);
      },
      expression: "update.contact.phone"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.website.text.label'),
      "rules": _vm.requiredRule,
      "hint": _vm.$t('components.partner.PartnerSettingsForm.website.text.hint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.update.websites[0].text,
      callback: function callback($$v) {
        _vm.$set(_vm.update.websites[0], "text", $$v);
      },
      expression: "update.websites[0].text"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.website.link.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.website.link.hint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.update.websites[0].link,
      callback: function callback($$v) {
        _vm.$set(_vm.update.websites[0], "link", $$v);
      },
      expression: "update.websites[0].link"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.agb.text.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.agb.text.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.agbUrl.text,
      callback: function callback($$v) {
        _vm.$set(_vm.update.agbUrl, "text", $$v);
      },
      expression: "update.agbUrl.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.agb.link.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.agb.link.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.agbUrl.link,
      callback: function callback($$v) {
        _vm.$set(_vm.update.agbUrl, "link", $$v);
      },
      expression: "update.agbUrl.link"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.privacy.text.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.privacy.text.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.privacyUrl.text,
      callback: function callback($$v) {
        _vm.$set(_vm.update.privacyUrl, "text", $$v);
      },
      expression: "update.privacyUrl.text"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.privacy.link.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.privacy.link.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.privacyUrl.link,
      callback: function callback($$v) {
        _vm.$set(_vm.update.privacyUrl, "link", $$v);
      },
      expression: "update.privacyUrl.link"
    }
  }), _c('v-textarea', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.dataProtection.label.text.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.dataProtection.label.text.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.dataProtectionLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "dataProtectionLabel", $$v);
      },
      expression: "update.dataProtectionLabel"
    }
  }), _c('v-textarea', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.dataProtection.hint.text.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.dataProtection.hint.text.hint'),
      "disabled": _vm.disabled,
      "outlined": ""
    },
    model: {
      value: _vm.update.dataProtectionHint,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "dataProtectionHint", $$v);
      },
      expression: "update.dataProtectionHint"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-palette")])], 1), _c('v-list-item-content', [_c('custom-field-boolean', {
    attrs: {
      "disabled": _vm.disabled,
      "customField": {
        label: _vm.$t('views.Setting.vuetifyColor.title')
      }
    },
    model: {
      value: _vm.update.isVuetifyInPartnerColors,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "isVuetifyInPartnerColors", $$v);
      },
      expression: "update.isVuetifyInPartnerColors"
    }
  }), _c('custom-field-boolean', {
    attrs: {
      "disabled": _vm.disabled,
      "customField": {
        label: _vm.$t('views.Setting.navigationColors.title')
      }
    },
    model: {
      value: _vm.update.isNavigationInPartnerColors,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "isNavigationInPartnerColors", $$v);
      },
      expression: "update.isNavigationInPartnerColors"
    }
  }), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Colortheme "), _c('v-spacer'), !_vm.update.themes ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "small": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addColorTheme
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-palette")]), _vm._v(" Light Theme anlegen ")], 1) : _c('v-btn', {
    attrs: {
      "color": "error",
      "outlined": "",
      "small": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.removeColorTheme
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" Theme entfernen ")], 1)], 1), _vm.isLightPalette ? _c('v-list-item', [_c('v-list-item-content', [_vm._l(_vm.update.themes.light.palette, function (hex, index) {
    return _c('div', {
      key: 'palette' + index,
      staticClass: "d-flex align-center"
    }, [_c('v-avatar', {
      staticClass: "mr-2",
      attrs: {
        "size": "28",
        "tile": "false",
        "color": hex
      }
    }), _c('v-text-field', {
      attrs: {
        "outlined": "",
        "clearable": _vm.isThemeColorClearable,
        "value": _vm.getAvatarColor(hex),
        "type": "text",
        "disabled": _vm.disabled,
        "rules": _vm.requiredRule
      },
      on: {
        "input": function input($event) {
          return _vm.updatePaletteColor($event, index);
        },
        "click:clear": function clickClear($event) {
          return _vm.splicePaletteColor(index);
        }
      }
    })], 1);
  }), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "elevation": "0",
      "color": "success",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addPaletteColor
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 2)], 1) : _vm._e()], 1)], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-message-processing")])], 1), _c('v-list-item-content', [_c('custom-field-boolean', {
    attrs: {
      "disabled": _vm.disabled,
      "customField": {
        label: 'Whatsapp'
      }
    },
    model: {
      value: _vm.update.isWhatsApp,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "isWhatsApp", $$v);
      },
      expression: "update.isWhatsApp"
    }
  })], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-file-multiple-outline")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.letterhead.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.letterhead.hint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.update.letterheadUri,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "letterheadUri", $$v);
      },
      expression: "update.letterheadUri"
    }
  })], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-certificate-outline")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerSettingsForm.sepaCreditorId.text.label'),
      "hint": _vm.$t('components.partner.PartnerSettingsForm.sepaCreditorId.text.hint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.update.sepaCreditorId,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "sepaCreditorId", $$v);
      },
      expression: "update.sepaCreditorId"
    }
  })], 1)], 1), !_vm.isTHGContext ? _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-google-my-business")])], 1), _c('v-list-item-content', [_c('div', [_c('v-autocomplete', {
    attrs: {
      "disabled": _vm.disabled,
      "outlined": "",
      "placeholder": "Start typing to Search Google",
      "label": "Search Google",
      "items": _vm.googlePlaceRes,
      "search-input": _vm.search,
      "loading": _vm.isGoogleLoading,
      "item-text": "name",
      "hide-no-data": "",
      "return-object": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    model: {
      value: _vm.place,
      callback: function callback($$v) {
        _vm.place = $$v;
      },
      expression: "place"
    }
  })], 1), _c('div', [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": "Google Place ID",
      "hint": "Google Place ID. https://developers.google.com/maps/documentation/places/web-service/place-id",
      "disabled": _vm.disabled,
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.update.placeId,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "placeId", $$v);
      },
      expression: "update.placeId"
    }
  })], 1), _c('div', [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": "Google Maps URL",
      "hint": "Google Maps URL",
      "disabled": _vm.disabled,
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.update.googleMapsUri,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "googleMapsUri", $$v);
      },
      expression: "update.googleMapsUri"
    }
  })], 1), _c('div', [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": "Google Merchant ID",
      "hint": "Google Merchant ID. https://support.google.com/paymentscenter/answer/7163092",
      "disabled": _vm.disabled,
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.update.merchantId,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "merchantId", $$v);
      },
      expression: "update.merchantId"
    }
  })], 1)])], 1) : _vm._e(), _vm.update.taxRates ? _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-robber")])], 1), _c('v-list-item-content', [_vm._l(_vm.update.taxRates, function (item, index) {
    return _c('div', {
      key: 'tr' + index
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('components.partner.PartnerSettingsForm.taxRate.label'),
        "hint": _vm.$t('components.partner.PartnerSettingsForm.taxRate.hint'),
        "suffix": "%",
        "outlined": "",
        "clearable": "",
        "value": item,
        "type": "number",
        "disabled": _vm.disabled
      },
      on: {
        "input": function input($event) {
          return _vm.updateTaxRate($event, index);
        },
        "click:clear": function clickClear($event) {
          return _vm.spliceTaxRate(index);
        }
      }
    })], 1);
  }), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "elevation": "0",
      "color": "success",
      "data-test-add-welcome-text": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addTaxRate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerSettingsForm.taxRate.addButton")) + " ")])], 2)], 1) : _vm._e(), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-chat-question-outline")])], 1), _c('v-list-item-content', [_c('div', [_c('v-select', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.damageTypes.label'),
      "multiple": "",
      "items": Object.values(_vm.DamageTypeEnum),
      "outlined": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.update.damageTypes,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "damageTypes", $$v);
      },
      expression: "update.damageTypes"
    }
  })], 1), _c('div', [_c('v-select', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.companyServices.label'),
      "multiple": "",
      "items": Object.values(_vm.CompanyServiceEnum),
      "outlined": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.update.companyServices,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "companyServices", $$v);
      },
      expression: "update.companyServices"
    }
  })], 1), _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.clearanceMarkUpInPercent.label'),
      "outlined": "",
      "persistent-hint": "",
      "hint": _vm.$t('components.partner.PartnerSettingsForm.clearanceMarkUpInPercent.hint'),
      "clearable": "",
      "disabled": _vm.disabled,
      "type": "number"
    },
    model: {
      value: _vm.update.clearanceMarkUpInPercent,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "clearanceMarkUpInPercent", _vm._n($$v));
      },
      expression: "update.clearanceMarkUpInPercent"
    }
  })], 1), _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.clearanceRoundingStep.label'),
      "outlined": "",
      "persistent-hint": "",
      "hint": _vm.$t('components.partner.PartnerSettingsForm.clearanceRoundingStep.hint'),
      "clearable": "",
      "disabled": _vm.disabled,
      "type": "number"
    },
    model: {
      value: _vm.update.clearanceRoundingStep,
      callback: function callback($$v) {
        _vm.$set(_vm.update, "clearanceRoundingStep", _vm._n($$v));
      },
      expression: "update.clearanceRoundingStep"
    }
  })], 1)])], 1)], 1)], 1), _c('v-tab-item', {
    key: "1"
  }, [_c('PartnerCreateOrUpdateLandingpageSettigns', {
    attrs: {
      "settings": _vm.update,
      "disabled": _vm.disabled
    }
  })], 1), _c('v-tab-item', {
    key: "2"
  }, [_c('PartnerCreateOrUpdateReportSettings', {
    attrs: {
      "reportSettings": _vm.update.reportSettings,
      "disabled": _vm.disabled
    }
  })], 1), _c('v-tab-item', {
    key: "3"
  }, [_c('v-form', {
    ref: "appForm",
    model: {
      value: _vm.appFormValid,
      callback: function callback($$v) {
        _vm.appFormValid = $$v;
      },
      expression: "appFormValid"
    }
  }, [_vm.update.appSettings ? _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-bus-stop-covered")])], 1), _c('v-list-item-content', [_c('div', [_c('v-select', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.coverageTypeFilter.label'),
      "multiple": "",
      "items": Object.values(_vm.CoverageTypeEnum),
      "outlined": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.update.appSettings.coverageTypeFilter,
      callback: function callback($$v) {
        _vm.$set(_vm.update.appSettings, "coverageTypeFilter", $$v);
      },
      expression: "update.appSettings.coverageTypeFilter"
    }
  })], 1)])], 1)], 1) : _vm._e()], 1)], 1), _c('v-tab-item', {
    key: "4"
  }, [_c('PartnerCreateOrUpdateLicense', {
    attrs: {
      "settings": _vm.update,
      "disabled": _vm.disabled
    }
  })], 1), _c('v-tab-item', {
    key: "5"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-4 mb-n7"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerSettingsForm.inbox.title")) + " ")]), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": function click($event) {
        _vm.isAddUpdateInboxesDialogActive = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerSettingsForm.inbox.addButton")) + " ")])], 1), _c('v-card-text', _vm._l(_vm.update.inboxes, function (inbox, index) {
    return _c('v-list-item', {
      key: 'inboxes' + index,
      attrs: {
        "outlined": ""
      }
    }, [_c('v-list-item-action', [_c('v-checkbox', {
      attrs: {
        "disabled": _vm.disabled
      },
      model: {
        value: inbox.isActive,
        callback: function callback($$v) {
          _vm.$set(inbox, "isActive", $$v);
        },
        expression: "inbox.isActive"
      }
    })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(inbox.name) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(inbox.identifier) + " ")])], 1), _c('v-list-item-action', [!_vm.disabled ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.update.inboxes.splice(index, 1);
        }
      }
    }, [_c('v-icon', [_vm._v(" mdi-close ")])], 1) : _vm._e()], 1)], 1);
  }), 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAddUpdateInboxesDialogActive,
      "title": _vm.$t('components.partner.PartnerSettingsForm.inbox.dialog.title'),
      "rightDisabled": !_vm.isUpdateInboxesValid
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAddUpdateInboxesDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAddUpdateInboxesDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAddUpdateInboxesDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAddUpdateInboxesDialogActive = false;
      },
      "rightClick": _vm.addNewInbox
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isUpdateInboxesValid,
      callback: function callback($$v) {
        _vm.isUpdateInboxesValid = $$v;
      },
      expression: "isUpdateInboxesValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.partner.PartnerSettingsForm.inbox.dialog.name.label'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.newInbox.name,
      callback: function callback($$v) {
        _vm.$set(_vm.newInbox, "name", $$v);
      },
      expression: "newInbox.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.mailRule,
      "label": _vm.$t('components.partner.PartnerSettingsForm.inbox.dialog.identifier.label'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.newInbox.identifier,
      callback: function callback($$v) {
        _vm.$set(_vm.newInbox, "identifier", $$v);
      },
      expression: "newInbox.identifier"
    }
  }), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerSettingsForm.inbox.dialog.active.label'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.newInbox.isActive,
      callback: function callback($$v) {
        _vm.$set(_vm.newInbox, "isActive", $$v);
      },
      expression: "newInbox.isActive"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', [_c('v-row', [!_vm.disabled ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "ml-16 mb-6",
    attrs: {
      "disabled": !_vm.valid,
      "loading": _vm.isLoading,
      "outlined": "",
      "large": "",
      "color": "primary",
      "data-test-profile-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("mdi-content-save")]), _vm._v(" " + _vm._s(_vm.$t("components.profile.EditProfileDialog.save")) + " ")], 1)], 1) : _vm._e(), !_vm.disabled ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "ml-16 mb-6",
    attrs: {
      "loading": _vm.isLoading,
      "outlined": "",
      "large": "",
      "color": "warning",
      "data-test-profile-abort": ""
    },
    on: {
      "click": _vm.abort
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" " + _vm._s(_vm.$t("components.profile.EditProfileDialog.abort")) + " ")], 1)], 1) : _vm._e(), _vm.disabled ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-16 mb-6 ",
    attrs: {
      "loading": _vm.isLoading,
      "outlined": "",
      "large": "",
      "color": "primary",
      "data-test-profile-edit": ""
    },
    on: {
      "click": function click($event) {
        _vm.disabled = !_vm.disabled;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.$t("components.profile.EditProfileDialog.edit")) + " ")], 1)], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }